import { appMethod as app } from '@utils/app';

import ScratchClass from '@utils/scratch';
import { getCurrentPageQueryParams, convertLineStyleData } from '@utils/tools';
import { TopNav } from '@common/top-nav/TopNav';
import OfficialPage from '../OfficialPage';

import './TransferPaySuccess.less';

export default class TransferPaySuccess extends OfficialPage {
  state = {
    totalPayment: '',
    payInfo: {},
    hideScratchCanvas: true,
    isShowScratchBtn: '',
    scratchIsFail: true, // 显示未中奖
    scratchIsPrize: true, // 显示中奖
    scratchIsDurMax: false,
    scratchIsLimit: false,
    scratchIsComfort: true, // 显示安慰奖
    scratchIsDegree: false,
    scratchInfo: {}, // 获取活动信息
    scratchTimes: 0, // 剩余次数
    scratchId: '', // 活动号
    scratchIsScroll: true, //刮刮乐当在 canvas 中移动时且有绑定手势事件时禁止屏幕滚动以及下拉刷新
    time_limit: '',
    scratchPrizeTitle: '', // 中奖名称
    vipCardInfo: { isShow: false }, // 会员卡信息
    couponList: [
      // 优惠券列表
      {
        active_title: '领取后立即生效，',
        condition: '10.00',
        discount: '10.00',
        discount_type: 'coupon',
        end_use_date: '9999-12-31',
        end_use_time: '23:59:00',
        expire_day_count: 0,
        name: '满10减9.9',
        start_use_date: '1000-01-01',
        start_use_time: '00:00:00',
        title: '满10减9.9（满10.00减9.90）',
        type: '0',
        value: '9.90'
      }
    ],
    benefitConfig: {},
    collectBenefitData: {}, // 集集乐数据
    starData: [], // 集集乐的星 light:已集样式 dark:未集样式
    payActivity: '', // 支付营销活动类型
    isShowVipCardDialog: false, // 是否显示会员卡弹窗
    ifUserInfo: false, // 是否存在相应的用户信息
    userCityArr: ['', '', ''], // 用户城市信息的集合   [country, pri, city]
    userInfo: {}, // 会员信息
    isRecvVipCard: false, // 是否已会员卡领取
    transferConfig: {}, // 当面付配置
    appTitle: '',
    isGetPhoneNumber: false, // 是否获得手机授权
    ifWxCoupon: false,
    timestamp: '',
    signature: '',
    ifGetComfort: false
  }
  orderId = ''

  constructor(props) {
    super(props);
    document.title = '交易成功';
  }

  componentDidMount(options = getCurrentPageQueryParams()) {
    let that = this
    let franchisee = options.franchisee || ''
    let appTitle = franchisee ? '' : app.getAppTitle()
    this.setData({
      appTitle: appTitle,
      franchisee: franchisee
    })
    if (franchisee) {
      this.getAppShopByPage()
    }
    this.orderId = options.detail || ''
    this.getTransferOrderConfig()
    this.getGoldenData(options.detail)
    setTimeout(() => {
      this.getOrderDetail()
    })
  }

  getTransferOrderConfig = () => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppTransferOrder/GetTransferOrderConfig',
      method: 'post',
      data: {
        sub_shop_app_id: _this.data.franchisee
      },
      success: function(res) {
        _this.setData({
          transferConfig: res.data
        })
      }
    })
  }
  setPaySuccessBenefitConfig = config => {
    let that = this
    let payActivity = ''
    if (
      Number(that.data.payInfo.total_price) +
      Number(that.data.payInfo.use_balance) <
      config.condition_price
    ) {
      return
    }
    if (config.type === 'scratch_card') {
      that.activityInit()
    } else if (config.type === 'vipcard_permission') {
      that.judgmentVipCard(config.vipcard_id)
    } else if (config.type === 'coupon') {
      that.setCouponInfo(config.coupon_id)
      payActivity = config.type
    } else if (config.type === 'collectme') {
      that.checkAppCollectmeStatus()
    } else if (config.type === 'balance') {
      if (config.balance_type == 1) {
        config.balance =
          (config.balance_value * this.data.totalPayment) % 1 === 0
            ? config.balance_value * this.data.totalPayment
            : Math.floor(config.balance_value * this.data.totalPayment * 100) /
            100
      } else {
        config.balance = config.balance_value
      }
      payActivity = config.type
    } else {
      payActivity = config.type
    }
    that.setData({
      benefitConfig: config,
      payActivity: payActivity
    })
  }
  activityInit = () => {
    let that = this
    if (app.isLogin()) {
      that.getScratchData()
    } else {
      app.goLogin({
        success: function() {
          that.getScratchData()
        }
      })
    }
  }
  getScratchData = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getActivity',
      method: 'post',
      data: { category: 3 },
      success: function(res) {
        let mes = res.data
        that.scratchInit()
        that.setData({
          scratchInfo: mes,
          scratchId: mes.id,
          scratchTimes: mes.times,
          time_limit: mes.time_limit
        })
      }
    })
  }
  scratchInit = () => {
    let that = this
    let systemInfo = app.globalData.systemInfo
    let width = (722 * systemInfo.windowWidth) / 750
    let height = (290 * systemInfo.windowWidth) / 750
    that.scratch = new ScratchClass(that, {
      canvasWidth: width,
      canvasHeight: height,
      imageResource:
        app.getSiteBaseUrl() +
        '/index.php?r=Download/DownloadResourceFromUrl&url=https://chn.jisuapp.cn/static/webapp/images/scratchMovie.png',
      maskColor: 'red',
      r: 18,
      callback: () => {
        that.setData({
          hideScratchCanvas: true
        })
        if (that.data.ifWxCoupon) {
          setTimeout(function() {
            that.toAddCard()
          }, 500)
        }
      },
      imgLoadCallback: () => {
        setTimeout(function() {
          that.setData({
            hideScratchCanvas: false,
            isShowScratchBtn: true,
            payActivity: that.data.benefitConfig.type
          })
        }, 10)
      }
    })
  }
  startScratch = () => {
    let that = this
    if (!that.data.scratchId) {
      return
    }
    if (that.data.time_limit == 0) {
      that.setData({
        scratchIsLimit: true,
        hideScratchCanvas: true,
        isShowScratchBtn: false
      })
    } else {
      console.log(that.data.scratchTimes)
      if (that.data.scratchTimes <= 0) {
        if (that.data.scratchInfo.time_share == 0) {
          that.setData({
            scratchIsDegree: true,
            hideScratchCanvas: true,
            isShowScratchBtn: false
          })
        } else {
          that.setData({
            scratchIsDurMax: true,
            hideScratchCanvas: true,
            isShowScratchBtn: false
          })
        }
      } else {
        if (that.scratchLoading) {
          return false
        }
        that.setData({
          isShowScratchBtn: false
        })
        that.scratchLoading = true
        that.getLottery()
      }
    }
  }
  getLottery = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/lottery',
      method: 'post',
      hideLoading: true,
      data: {
        activity_id: that.data.scratchId,
        app_id: app.globalData.appId
      },
      success: function(res) {
        let data = res.data,
          newData = {}
        that.scratch.start()
        if (data.title == '谢谢参与') {
          newData = {}
          newData['scratchIsFail'] = false
          newData['scratchTimes'] = data.time
          newData['time_limit'] = data.time_limit
          that.setData(newData)
        } else {
          newData = {}
          if (data.is_comfort == 1) {
            newData['scratchIsComfort'] = false
          } else {
            newData['scratchIsPrize'] = false
            newData['scratchPrizeTitle'] = data.title
          }
          let ifWxCoupon = data.card_id || false
          newData['ifWxCoupon'] = ifWxCoupon
          newData['timestamp'] = data.timestamp || ''
          newData['signature'] = data.signature || ''
          newData['scratchTimes'] = data.time
          newData['time_limit'] = data.time_limit
          that.setData(newData)
        }
        that.scratchLoading = false
      },
      successStatusAbnormal: function(res) {
        that.scratchLoading = false
        if (res.status == 1) {
          that.setData({
            isShowScratchBtn: true
          })
        }
      }
    })
  }
  failBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideScratchCanvas: false,
      scratchIsFail: true
    })
    setTimeout(function() {
      that.setData({
        isShowScratchBtn: true
      })
    }, 100)
  }
  winningBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideScratchCanvas: false,
      scratchIsPrize: true
    })
    setTimeout(function() {
      that.setData({
        isShowScratchBtn: true
      })
    }, 100)
  }
  comfortBtnClick = () => {
    let that = this
    that.scratch.reset()
    that.setData({
      hideScratchCanvas: false,
      scratchIsComfort: true
    })
    setTimeout(function() {
      that.setData({
        isShowScratchBtn: true
      })
    }, 100)
  }
  getGoldenData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=appLotteryActivity/getTimeAfterConsume',
      method: 'post',
      data: {
        order_id: id,
        sub_app_id: that.data.franchisee
      },
      success: function(data) {
        if (data.integral) {
          //支付获取积分
          that.setData({
            rewardPointObj: {
              showModal: true,
              count: data.integral,
              callback: ''
            }
          })
        }
      }
    })
  }
  getOrderDetail = () => {
    let that = this
    app.getOrderDetail({
      data: {
        order_id: this.orderId
      },
      success: function(res) {
        let form_data = res.data[0].form_data
        that.setData({
          totalPayment: form_data.total_price,
          payInfo: form_data
        })
        if (
          form_data.pay_success_benefit_info &&
          form_data.pay_success_benefit_info[0] &&
          form_data.pay_success_benefit_info[0].status === 0
        ) {
          that.setPaySuccessBenefitConfig(
            form_data.pay_success_benefit_info[0].benefit_info
          )
        }
      }
    })
  }
  transferSuccessCallback = () => {
    let router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  goToOrderDetail = () => {
    let franchiseeParam = this.data.franchisee
      ? '&franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/eCommerce/pages/transferOrderDetail/transferOrderDetail?detail=' +
      this.orderId +
      franchiseeParam,
      1
    )
  }
  setCouponInfo = id => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetCouponInfo',
      data: {
        coupon_id: id
      },
      hideLoading: true,
      success: function(res) {
        let couponList = []
        couponList.push(res.data)
        _this.setData({
          couponList: couponList
        })
      }
    })
  }
  recvCoupon = e => {
    let _this = this,
      couponId = e.currentTarget.dataset.couponid
    app.sendRequest({
      url: '/index.php?r=AppShop/recvCoupon',
      data: {
        coupon_id: couponId
      },
      hideLoading: true,
      success: function(res) {}
    })
  }
  checkAppCollectmeStatus = () => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CheckAppCollectmeStatus',
      data: {
        order_id: that.orderId
      },
      success: function(res) {
        if (res.valid === 1) {
          return
        }
        that.getCollectBenefitData(that.orderId)
      }
    })
  }
  getCollectBenefitData = id => {
    let that = this
    app.sendRequest({
      url: '/index.php?r=AppMarketing/CollectmeSendCoupon',
      data: {
        order_id: id
      },
      hideLoading: true,
      success: function(res) {
        let starData = []
        for (let i = 0; i < res.data.star_num; i++) {
          starData.push('light')
        }
        for (let i = 0; i < res.data.collect_num - res.data.star_num; i++) {
          starData.push('dark')
        }
        that.setData({
          collectBenefitData: res.data,
          starData: starData,
          payActivity: that.data.benefitConfig.type
        })
      }
    })
  }
  goToWheelDetail = () => {
    let franchiseeParam = this.data.franchisee
      ? '?franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/awardManagement/pages/luckyWheelDetail/luckyWheelDetail' +
      franchiseeParam,
      1
    )
  }
  goToGoldenEggs = () => {
    let franchiseeParam = this.data.franchisee
      ? '?franchisee=' + this.data.franchisee
      : ''
    app.turnToPage(
      '/awardManagement/pages/goldenEggs/goldenEggs' + franchiseeParam,
      1
    )
  }
  touchStart = e => {
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchMove = e => {
    console.log(e)
    if (!this.isStart) return
    let pos = this.drawRect(e.touches[0].x, e.touches[0].y)
    this.ctx.clearRect(pos[0], pos[1], pos[2], pos[2])
    this.ctx.draw(true)
  }
  touchEnd = e => {
    console.log(e)
    if (!this.isStart) return
    let { canvasWidth, canvasHeight, minX, minY, maxX, maxY } = this
    if (maxX - minX > 0.5 * canvasWidth && maxY - minY > 0.5 * canvasHeight) {
      this.ctx.draw()
      this.endCallBack && this.endCallBack()
      this.isStart = false
      this.page.setData({
        scratchIsScroll: true
      })
    }
  }
  goToUserCenter = () => {
    let router = app.getHomepageRouter()
    app.turnToPage('/pages/' + router + '/' + router, true)
  }
  judgmentVipCard = id => {
    let _this = this
    this.getEnableVipCardList(id, function() {
      app.sendRequest({
        url: '/index.php?r=AppShop/GetVIPCardInfo',
        data: { vip_id: id },
        success: res => {
          let cardInfo = res.data[0]
          _this.getUserVipLevel(cardInfo)
        }
      })
    })
  }
  getUserVipLevel = cardInfo => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppShop/GetVIPInfo',
      data: {},
      success: res => {
        let user_vip_level = res.data.level ? res.data.level : 0
        let user_vip_id = res.data.vip_id ? res.data.vip_id : 0
        if (user_vip_level <= +cardInfo.level && user_vip_id !== cardInfo.id) {
          cardInfo.isShow = true
          _this.setData({
            vipCardInfo: cardInfo,
            payActivity: _this.data.benefitConfig.type
          })
        }
      }
    })
  }
  getEnableVipCardList = (id, callback) => {
    let _this = this
    app.sendRequest({
      url: '/index.php?r=AppVipCard/GetEnableVipCardList',
      data: {
        sub_shop_app_id: _this.data.franchisee
      },
      success: res => {
        res.data.map(val => {
          if (val.id === id) {
            callback()
          }
        })
      }
    })
  }
  handleVipCard = () => {
    this.getCollectUserinfoConfig(() => {
      app.turnToPage(
        '/pages/userCenter/userCenter?card_id=' +
        this.data.vipCardInfo.id +
        '&is_no_condition_recv=' +
        1 +
        '&franchisee=' +
        this.data.franchisee
      )
    })
  }
  recvVipCard = () => {
    let _this = this
    app.sendRequest({
      data: {
        vipcard_id: _this.data.vipCardInfo.id,
        sub_shop_app_id: _this.data.franchisee
      },
      url: '/index.php?r=AppVipCard/RecvVipCard',
      hideLoading: true,
      success: res => {
        app.showToast({
          title: '开卡成功',
          icon: 'success'
        })
      }
    })
  }
  saveUserInfo = () => {
    let data = this.data.userInfo
    let _this = this
    let config = this.data.userInfoCollectConfig
    let newData = {}
    if (data.country === 'China') {
      data.country = '中国'
    }
    data.province = this.data.userCityArr[0]
    data.city = this.data.userCityArr[1]
    if (
      (config.collect_username == 1 && data.nickname === '') ||
      (config.collect_phone == 1 && !data.phone) ||
      (config.collect_birthday == 1 && data.birthday === '') ||
      (config.collect_region == 1 && (data.province === '' || data.city === ''))
    ) {
      app.showModal({
        content: '请填写完整的会员信息'
      })
      return
    }
    newData.nickname = data.nickname
    newData.phone = data.phone
    newData.birthday = data.birthday
    newData.country = data.country
    newData.province = data.province
    newData.city = data.city
    app.sendRequest({
      url: '/index.php?r=AppData/saveUserInfo',
      method: 'post',
      data: newData,
      success: function(res) {
        if (res.status === 0) {
          app.setUserInfoStorage(data)
          _this.recvVipCard()
        }
      }
    })
  }
  getCollectUserinfoConfig = callback => {
    let _this = this
    let userInfo = JSON.parse(JSON.stringify(app.getUserInfo()))
    app.sendRequest({
      data: {},
      url: '/index.php?r=AppVipCard/GetCollectUserinfoConfig',
      hideLoading: true,
      success: res => {
        if (res.data.need_collect_info) {
          callback()
        } else {
          _this.recvVipCard()
        }
      }
    })
  }
  closeVipCardDialog = e => {
    if (e.target.dataset.type === 'shadow') {
      this.setData({
        isShowVipCardDialog: false
      })
    }
  }
  getAppShopByPage = () => {
    let that = this
    let franchiseeId = this.data.franchisee
    app.sendRequest({
      url: '/index.php?r=AppShop/GetAppShopByPage',
      data: {
        sub_shop_app_id: franchiseeId
      },
      success: function(res) {
        let newdata = {},
          data = res.data[0]
        newdata['appTitle'] = data.name
        that.setData(newdata)
      }
    })
  }
  getPhoneNumber = e => {
    if (this.data.isGetPhoneNumber && userInfo.phone.length === 11) {
      return
    }
    let _this = this
    app.checkSession(function() {
      if (!e.detail.encryptedData) {
        return
      }
      app.sendRequest({
        hideLoading: true,
        url: '/index.php?r=AppUser/GetPhoneNumber',
        data: {
          encryptedData: e.detail.encryptedData || '',
          iv: e.detail.iv || ''
        },
        success: function(res) {
          app.setUserInfoStorage({
            phone: res.data
          })
          _this.setData({
            'userInfo.phone': res.data,
            isGetPhoneNumber: true
          })
        },
        successStatus5: function() {
          app.showModal({
            content: '获取手机号失败，请再次点击授权获取'
          })
          // app.goLogin({
          //   success: function() {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   },
          //   fail: function() {
          //     app.showModal({
          //       content: '获取手机号失败，请再次点击授权获取'
          //     })
          //   }
          // })
        }
      })
    })
  }
  inputUserInfo = e => {
    let setData = {}
    if (e.currentTarget.dataset.type === 'name') {
      setData = { 'userInfo.name': e.target.value }
    } else if (e.currentTarget.dataset.type === 'phone') {
      setData = { 'userInfo.phone': e.target.value }
    }
    this.setData(setData)
  }
  bindBirthdayChange = e => {
    this.setData({
      'userInfo.birthday': e.target.value
    })
  }
  bindCityChange = e => {
    this.setData({
      userCityArr: e.target.value
    })
  }
  toAddCard = () => {
    let _data = this.data,
      wxcouponId = _data.ifWxCoupon,
      _this = this
    app.addCard({
      cardList: [
        {
          cardId: wxcouponId,
          cardExt:
            '{"nonce_str":"' +
            _data.timestamp +
            '","timestamp":"' +
            _data.timestamp +
            '", "signature":"' +
            _data.signature +
            '"}'
        }
      ],
      success: function(res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: true
        })
        app.sendRequest({
          url: '/index.php?r=appLotteryActivity/recvWeChatCoupon',
          data: {
            card_id: res.cardList[0].cardId,
            sub_app_id: _data.franchisee,
            activity_id: _data.scratchId
          },
          success: function(res) {
            app.showModal({
              title: '提示',
              content: '领取卡券成功',
              showCancel: false
            })
          }
        })
      }
    })
  }
  shadeClose = el => {
    let _this = this,
      type = el.currentTarget.dataset.type
    app.showModal({
      title: '提示',
      content: '微信优惠券不领取到卡包，下次就不能再领取了哦，确定放弃优惠么？',
      showCancel: true,
      confirm: function(res) {
        _this.setData({
          ifWxCoupon: false,
          ifGetComfort: false
        })
        if (type == 1) {
          _this.winningBtnClick()
        } else if (type == 2) {
          _this.comfortBtnClick()
        }
      }
    })
  }
  config = {
    navigationBarTitleText: '支付成功'
  }

  render() {
    const {
      appTitle,
      totalPayment,
      payInfo,
      transferConfig,
      benefitConfig,
      vipCardInfo,
      payActivity,
      collectBenefitData,
      starData,
      couponList,
      isRecvVipCard,
      scratchIsFail,
      scratchIsPrize,
      scratchPrizeTitle,
      ifWxCoupon,
      scratchIsDurMax,
      scratchIsLimit,
      scratchIsComfort,
      ifGetComfort,
      scratchIsDegree,
      hideScratchCanvas,
      scratch,
      scratchIsScroll,
      isShowScratchBtn
    } = this.state
    return (
      <div className="official-page transfer-pay-success">
        <TopNav title="交易成功"/>
        <div>
          <div className="top-block">
            <div className="success-block"></div>
            <div className="transfer-mess">
              <div className="beneficiary">{appTitle}</div>
              <div className="price-block">
                ¥<span className="actually-price">{totalPayment}</span>
                <span className="original-price">
              {'¥' + payInfo.original_price}
            </span>
              </div>
            </div>
            <div className="discount-wrapper">
              {payInfo.discount_cut_price &&
              payInfo.discount_cut_price !== '0.00' && (
                <div className="discount-item">
                  <span>优惠金额</span>
                  <span>{'-¥' + payInfo.discount_cut_price}</span>
                </div>
              )}
              {!!+payInfo.use_balance && payInfo.use_balance !== '0.00' && (
                <div className="discount-item">
                  <span>储值抵扣</span>
                  <span>{'-¥' + payInfo.use_balance}</span>
                </div>
              )}
              {payInfo.send_integral_info &&
              !!+payInfo.send_integral_info.consume_send_integral && (
                <div className="discount-item">
                  <span>获得积分</span>
                  <span className="count">
                {'+' + payInfo.send_integral_info.consume_send_integral}
              </span>
                </div>
              )}
            </div>
            <div className="btn-wrapper">
              <div
                className="btn ok-btn"
                onClick={this.transferSuccessCallback}
              >
                完成
              </div>
              <div className="btn view-btn" onClick={this.goToOrderDetail}>
                查看订单
              </div>
            </div>
          </div>
          {/* TODO {transferConfig.ad_id && (
            <Ad className="ad-block" unitId={transferConfig.ad_id}></Ad>
          )} */}
          {payActivity && (
            <div className="activity">
              <div className="copyWriting">
                <div className="line"></div>
                <span className="text">活动</span>
              </div>
              {(benefitConfig.type === 'coupon' ||
                (benefitConfig.type === 'vipcard_permission' &&
                  vipCardInfo.isShow) ||
                benefitConfig.type === 'integral' ||
                benefitConfig.type === 'balance' ||
                benefitConfig.type === 'lucky_wheel' ||
                benefitConfig.type === 'golden_eggs') && (
                <div className="get-reward-text">
                  {'本次交易获得' +
                  (benefitConfig.type === 'coupon'
                    ? '优惠券'
                    : benefitConfig.type === 'vipcard_permission'
                      ? '会员卡'
                      : benefitConfig.type === 'integral'
                        ? '积分'
                        : benefitConfig.type === 'balance'
                          ? '储值金'
                          : benefitConfig.type === 'lucky_wheel'
                            ? '大转盘'
                            : benefitConfig.type === 'golden_eggs'
                              ? '砸金蛋'
                              : '') +
                  '奖励'}
                </div>
              )}
              {/*  集集乐  */}
              {payActivity === 'collectme' && (
                <div className="collect">
                  <div className="text">
                    {'集集乐个数: ' + collectBenefitData.star_num}
                  </div>
                  <div
                    className={
                      'star-block ' +
                      (starData && starData.length === 6 ? 'star-six' : '')
                    }
                  >
                    {starData.map((item, index) => {
                      return (
                        <React.Fragment key={index}>
                          {item == 'light' ? (
                              <img
                                className="star"
                                src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/start@2x.png"
                              />
                                ) : (
                                item == 'dark' && (
                                <img
                                  className="star"
                                  src="http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/star-empty@2x.png"
                                />
                                  )
                                  )}
                        </React.Fragment>
                        )
                      })}
                  </div>
                  {collectBenefitData.star_num ==
                      collectBenefitData.collect_num && (
                        <div className="star-full">
                          <div className="star-full-text">满</div>
                        </div>
                  )}
                  <div className="about">
                  {'消费满' +
                  collectBenefitData.value +
                  '元，累计一颗心，积满可获得优惠券' +
                  collectBenefitData.coupon_title +
                  '一张'}
                  </div>
                </div>
              )}
              {/*  优惠券  */}
              {payActivity === 'coupon' && (
                <div className="coupon">
                  {couponList.map((item, index) => {
                    return (
                      <div className="coupon-item" key={item.id}>
                        <div className="info">
                          <div className="coupon-title">{item.title}</div>
                          {item.type == 0 && (
                            <div className="use-condition">
                              {'使用条件：满' +
                              item.condition +
                              '元，减' +
                              item.value +
                              '元'}
                            </div>
                          )}
                          {item.type == 1 && (
                            <div className="use-condition">
                              {'使用条件: 打' + item.value + '折'}
                            </div>
                          )}
                          {item.type == 2 && (
                            <div className="use-condition">
                              {'使用条件：可抵扣' + item.value + '元'}
                            </div>
                          )}
                          {item.type == 3 && (
                            <div className="use-condition">
                              {item.extra_condition == '' ? (
                                <span>
                  {'使用条件: 直接兑换' +
                  item.coupon_goods_info.title}
                </span>
                              ) : item.extra_condition.price ? (
                                <span>
                  {'使用条件: 消费满' +
                  item.extra_condition.price +
                  '元可兑换' +
                  item.coupon_goods_info.title}
                </span>
                              ) : (
                                item.extra_condition.goods_id && (
                                  <span>
                    {'使用条件: 购买' +
                    item.condition_goods_info.title +
                    '可兑换' +
                    item.coupon_goods_info.title}
                  </span>
                                )
                              )}
                            </div>
                          )}
                          {item.type == 4 && (
                            <div className="use-condition">
                              {'使用条件: 储值金可充值' + item.value + '元'}
                            </div>
                          )}
                          {item.type == 5 && (
                            <div className="use-condition">
                              {'使用条件: ' + item.extra_condition}
                            </div>
                          )}
                          {couponList.length === 1 && (
                            <div
                              className="pending-btn2"
                              data-couponid={item.id}
                            >
                              已领取
                            </div>
                          )}
                          {/*  <view class="ico-moon icon-success-tip"></view>  */}
                        </div>
                        <div className="background-word-area">
                          <div className="background-circle"></div>
                          {item.type == 0 && (
                            <div className="background-word">减</div>
                          )}
                          {item.type == 1 && (
                            <div className="background-word">折</div>
                          )}
                          {item.type == 2 && (
                            <div className="background-word">代</div>
                          )}
                          {item.type == 3 && (
                            <div className="background-word">兑</div>
                          )}
                          {item.type == 4 && (
                            <div className="background-word">储</div>
                          )}
                          {item.type == 5 && (
                            <div className="background-word">通</div>
                          )}
                        </div>
                        {/*  <view class="pending-btn" wx:if="{{ couponList.length === 2 }}" data-couponid="{{ item.id }}" bindtap="recvCoupon">待领取</view>  */}
                      </div>
                    )
                  })}
                </div>
              )}
              {/*  会员卡  */}
              {payActivity === 'vipcard_permission' && vipCardInfo.isShow && (
                <div
                  className="vip-card"
                  style={convertLineStyleData('background-image: url(http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/vip-card-default.png)')}
                >
                  <img
                    className="card-img"
                    src={
                      vipCardInfo.logo
                        ? vipCardInfo.logo
                        : 'http://www.zhichiwangluo.com/zhichi_frontend/static/webapp/images/transfer/default-vip-card-logo.png'
                    }
                  />
                    <div className="card-info">
                      <div className="card-name">
                        {vipCardInfo.app_name + ' ' + vipCardInfo.title}
                      </div>
                      {vipCardInfo.discount != 0 ? (
                        <div className="card-mess">
                          {'开卡可享 ' + vipCardInfo.discount + '折'}
                        </div>
                      ) : vipCardInfo.coupon_list &&
                      vipCardInfo.coupon_list != '' ? (
                        <div className="card-mess">开卡可享 赠送优惠券</div>
                      ) : (
                        vipCardInfo.integral != 0 && (
                          <div className="card-mess">
                            {'开卡可享 赠送' + vipCardInfo.integral + '积分'}
                          </div>
                        )
                      )}
                    </div>
                    {!isRecvVipCard && (
                      <div className="card-btn" onClick={this.handleVipCard}>
                        立即开卡
                      </div>
                    )}
                    {isRecvVipCard && (
                      <div className="card-btn" onClick={this.goToUserCenter}>
                        立即使用
                      </div>
                    )}
                </div>
              )}
              {/*  积分  */}
              {payActivity === 'integral' && (
                <div className="integral">
                  <div className="integral-block">
                    <div className="text">获得额外积分</div>
                    <div className="num">
                      {'+' +
                      payInfo.send_integral_info
                        .pay_success_benefit_send_integral}
                    </div>
                  </div>
                </div>
              )}
              {/*  储值金  */}
              {payActivity === 'balance' && (
                <div className="recharge">
                  <div className="recharge-block">
                    <div className="text">获得额外储值金</div>
                    <div className="num">{'+' + benefitConfig.balance}</div>
                  </div>
                </div>
              )}
              {/*  大转盘  */}
              {payActivity === 'lucky_wheel' && (
                <div className="turntable" onClick={this.goToWheelDetail}>
                  <div className="tip">立即前往</div>
                </div>
              )}
              {/*  砸金蛋  */}
              {payActivity === 'golden_eggs' && (
                <div className="gold-egg" onClick={this.goToGoldenEggs}>
                  <div className="tip">立即前往</div>
                </div>
              )}
              {/*  刮刮乐  */}
              {payActivity === 'scratch_card' && (
                <div id="scratch">
                  <div className="scratchFail" hidden={scratchIsFail}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png" />
                      <div className="failTitle">
                        <div className="failText">很遗憾没有中奖哦</div>
                        <div className="failBtn" onClick={this.failBtnClick}>
                          再来一次
                        </div>
                      </div>
                  </div>
                  {/*  中奖  */}
                  <div className="scratchWinning" hidden={scratchIsPrize}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg2.png" />
                      <div className="winningTitle">
                        <div className="winningText">恭喜你获得了</div>
                        <div className="winningText winningValue">
                          {scratchPrizeTitle}
                        </div>
                        {ifWxCoupon ? (
                          <div className="btnGroup">
                            <div className="winningBtn" onClick={this.toAddCard}>
                              立即领取
                            </div>
                            <div
                              className="winningBtn"
                              onClick={this.shadeClose}
                              data-type="1"
                            >
                              再来一次
                            </div>
                          </div>
                        ) : (
                          <div
                            className="winningBtn"
                            onClick={this.winningBtnClick}
                          >
                            再来一次
                          </div>
                        )}
                      </div>
                  </div>
                  {/*  次数不足，分享可获得次数  */}
                  <div className="scratchDurMax" hidden={!scratchIsDurMax}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png" />
                      <div className="durMaxTitle">
                        <div className="durMaxText">
                          对不起，您的刮奖次数不足，
                        </div>
                        <div className="durMaxText">分享即可获取次数哦~</div>
                      </div>
                  </div>
                  {/*  次数已达到上限  */}
                  <div className="scratchLimit" hidden={!scratchIsLimit}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png" />
                      <div className="limitTitle">
                        <div className="limitText">
                          今日刮奖次数已达到上限，
                        </div>
                        <div className="limitText">明日可继续参与刮奖哦~</div>
                      </div>
                  </div>
                  {/*  安慰奖  */}
                  <div className="scratchComfort" hidden={scratchIsComfort}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg2.png" />
                      <div className="comfortTitle">
                        {ifGetComfort ? (
                          <div className="comfortText">
                            已领取，在微信卡包中查看哦~
                          </div>
                        ) : (
                          <div className="comfortText" className="comfortText">
                            又没中奖，送你一个小礼品
                          </div>
                        )}
                        {!ifWxCoupon && !ifGetComfort && (
                          <div className="comfortText">
                            >在优惠券卡包进行查收哦~
                          </div>
                        )}
                        {ifWxCoupon ? (
                          <div className="btnGroup">
                            <div className="comfortBtn" onClick={this.toAddCard}>
                              立即领取
                            </div>
                            <div
                              className="comfortBtn"
                              onClick={this.shadeClose}
                              data-type="2"
                            >
                              知道了
                            </div>
                          </div>
                        ) : (
                          <React.Fragment>
                            {!ifGetComfort && (
                              <div className="comfortText">
                                在优惠券卡包进行查收哦~
                              </div>
                            )}
                            <div
                              className="comfortBtn"
                              onClick={this.comfortBtnClick}
                            >
                              知道了
                            </div>
                          </React.Fragment>
                        )}
                      </div>
                  </div>
                  {/*  次数不足，不可分享  */}
                  <div className="scratchDegree" hidden={!scratchIsDegree}>
                    <img src="http://www.zhichiwangluo.com/static/webapp/images/transfer/scratch-bg.png" />
                      <div className="degreeTitle">
                        <div className="degreeText">
                          对不起，您本次获取的刮奖次数不足
                        </div>
                      </div>
                  </div>
                  <div
                    hidden={hideScratchCanvas}
                    className="scratch_wp"
                    style={convertLineStyleData(
                      'width: ' +
                      scratch.width +
                      'px; height: ' +
                      scratch.height +
                      'px;'
                    )}
                  >
                    <canvas
                      className="scratch-canvas"
                      width={scratch && scratch.width}
                      height={scratch && scratch.height}
                      id="scratch-canvas"
                      onTouchStart={this.touchStart}
                      onTouchMove={this.touchMove}
                      onTouchEnd={this.touchEnd}
                    ></canvas>
                    {isShowScratchBtn && (
                      <div className="showArea">
                        <div className="showTitle">赢取优惠大奖</div>
                        <div className="showBtn" onClick={this.showAreaClick}>
                          点我刮奖
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              )}
            </div>
          )}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/official-page/transfer-pay-success/TransferPaySuccess.jsx